import axios from 'axios';
import { baseURL } from '../baseURL';
import Cookies from "js-cookie";

export const getLateDeliveries = (currentPage) => {
    const token = Cookies.get('token');
    return axios.get(`${baseURL}amantrans/1688-not-arrived?page=${currentPage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};
